module.exports = require("./agq.d.ts");